module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/parameters/parameters-page/parameters-page.component.css
// module id = ./src/app/components/parameters/parameters-page/parameters-page.component.css
// module chunks = main